import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/payment_succeeded.svg'


const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "container-fluid py-3 page-main-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-center page-main-title" }
const _hoisted_5 = { class: "white-text" }
const _hoisted_6 = { class: "container-fluid underline-container" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row text-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center py-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid",
    "data-aos": "zoom-in",
    "data-aos-easing": "ease-in-out",
    "data-aos-duration": "1000",
    alt: "download icon"
  })
], -1)
const _hoisted_10 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "hc0 bold blue-text" }
const _hoisted_13 = { class: "mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.locale.payment_success1), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          ($setup.data.inputValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "payment-success-input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.inputValue) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, $setup.data.inputValue]
                ]),
                _createElementVNode("input", {
                  type: "text",
                  class: "payment-success-button",
                  value: $setup.locale.payment_success2,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.copyToClipboard && $setup.copyToClipboard(...args)))
                }, null, 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_12, _toDisplayString($setup.locale.payment_success3), 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString($setup.locale.payment_success4), 1)
        ])
      ])
    ])
  ]))
}